<template>
  <div>
    <div :id="screenName" v-if="contentNotFound">
      <div class="collection-title">
        <h2>{{ screen.title.eng || screen.title.default }}</h2>
      </div>
      <GridLayoutPlaceholder v-if="interSected && !sliderContents" :displayType="screen.displayType">
      </GridLayoutPlaceholder>
      <Grid :contents="sliderContents" :isScrollable="isScrollable" @loadMore="reachEnd()"
        :playerInstance="playerInstance" :displayType="screen.displayType"
        v-else-if="!interSected && sliderContents && sliderContents.length > 0"></Grid>
    </div>
    <!-- <div v-else>
      <span>contentNotFound_{{ contentNotFound }}</span>
      <span>sliderContents_{{ sliderContents.length }}</span>
      <span>totalCountValue_{{ totalCountValue }}</span>
    </div> -->
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapGetters } from "vuex";
import Intersect from 'vue-intersect'
import { store } from "@/store/store";
import Utility from "@/mixins/Utility.js";

export default {
  props: {
    screen: {
      type: Object,
    },
    id: {
      type: String,
    },
    screenName: {
      type: String,
    },
    localLang: {
      type: String,
    },
    playerInstance: {
      type: Object,
    },
    screenId: {
      type: String,
    },
  },
  data() {
    return {
      contentList: false,
      showSlider: true,
      sliderContents: null,
      localDisplayLang: null,
      isMpegRequired: false,
      loading: true,
      contentNotFound: true,
      currentPage: 1,
      totalCountValue: 0,
      checkIsok: null,
      interSected: false,
      isScrollable: false
    };
  },
  computed: {
    ...mapGetters(["getToken", "currentBrowser", "subscriberid"]),
  },
  watch: {
    screenName() {
      this.sliderContents = null;
      this.loadCategory();
    }
  },
  created() {
    // this.isMpegRequired = this.checkMpegRequired();
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;

    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLang = data;
      // this.loading = true;
      this.loadCategory();
    });
  },
  mounted() {
    console.log('screen', this.screen);
    this.createObserver();
    // this.loadCategory();
  },
  methods: {
    reachEnd() {
      console.log('reachEnd', this.sliderContents.length, this.totalCountValue)
      if (this.totalCountValue > this.sliderContents.length) {
        this.currentPage = this.currentPage + 1;
        this.loadCategory();
      } else {
        this.isScrollable = false;
      }
    },
    filterContentList(response) {
      if (!response.reason) {
        this.interSected = false;
        this.checkIsok = false;

        this.loading = false;
        this.contentList = true;
        this.sliderContents = [...this.sliderContents, ...response.data];
        //   this.sliderContents = itemCase;
        // this.sliderContents.push(response.data)
        this.totalCountValue = response.totalcount;
        let dataLength = this.sliderContents.length;
        this.isScrollable = this.totalCountValue <= dataLength ? false : true;
        eventBus.$emit("on-data-callback", { "index": this.id, "is_data_available": dataLength > 0 });
      } else {
        // this.contentList = true;
        // this.showSlider = false;
        this.loading = false;
        this.checkIsok = false;
        this.contentNotFound = false;
        // eventBus.$emit("on-data-callback", {"index": this.id, "is_data_available": false});

      }
    },
    checkMpegRequired() {
      let isMpegRequired = false;
      let videoTag = document.createElement("video");
      let platformOs = navigator.platform;

      if (videoTag.canPlayType("application/vnd.apple.mpegurl")) {
        if (platformOs.startsWith("Mac")) {
          isMpegRequired = true;
        }
      }

      return isMpegRequired;
    },
    getEndPoint() {
      const sectionType = this.screen.sectionType;
      const itemType = this.screen.itemType;

      if (sectionType == "ITEMLIST" && itemType == "CONTENT") {
        return "subscriber/v1/content"
      } else if (sectionType == "ITEMLIST" && itemType == "TRAILERS") {
        return "subscriber/v1/metadata/trailer"
      } else if (sectionType == "ITEMLIST" && itemType == "CASTNCREW") {
        return "subscriber/v1/metadata/castncrew"
      } else {
        return "subscriber/v1/content"
      }
    },
    categoryList(data) {
      store
        .dispatch("contentList", data)
        .then((response) => {
          if (response.data) {
            if (data.type && data.type === "bold") {
              eventBus.$emit("bold-contents", response.data);
            } else {
              this.filterContentList(response.data);
            }
          }
        })
        .catch((error) => { console.log(error, 'error') });
    },
    loadCategory() {
      // if(!this.loading){
      //   return;
      // }
      if (this.screen) {
        if (this.screen.itemType === "PROMOTIONS") {
          this.interSected = false;
          this.sliderContents = this.screen.sectionData || [];
          console.log("PROMOTIONS", this.screen.sectionData, this.sliderContents)
          return;
        }

        let payload = {
          endpoint: this.screen.endpoint || this.getEndPoint(),
          id: this.id,
          params: this.screen.parameters || this.screen.sectionData || {}
        };

        if (this.screen.sectionType == "ITEMLIST") {
          let strItem = ''
          let item = this.screen.sectionData.map((data) => {
            // strItem += data.id + ","
            return data.id;
          })
          strItem = strItem.substring(0, strItem.length - 1);
          if (this.screen.itemType == "CONTENT") {
            payload.params = {
              contentlist: JSON.stringify(item),
              orderby: { "objectid": item }
            }
          } else {
            payload.params = {
              contentlist: JSON.stringify(item)
            }
          }

        }
        let subscriberProfileDetails = localStorage.getItem("subscriberProfileDetails");

        if (subscriberProfileDetails) {
          subscriberProfileDetails = JSON.parse(subscriberProfileDetails);
        }
        if (payload.params && typeof payload.params == "object") {
          payload.params.page = this.currentPage;
          payload.params.displaylanguage = this.localDisplayLang;
          if (this.isMpegRequired == true) {
            payload.params.mpegtspackage = "YES";
          }
          // if (subscriberProfileDetails && subscriberProfileDetails.kidsmode === "YES") {
          //   payload.params.genre = "Kids";
          // }
        }
        // this.loading = true;
        // this.contentList = false;
        // this.showSlider = true;

        // eventBus.$emit("category-list", payload);
        this.categoryList(payload)

      }
    },
    createObserver() {
      let observer;
      let boxElement = document.getElementById(`${this.screenName}`);
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      };

      observer = new IntersectionObserver(this.handleIntersect, options);
      observer?.observe(boxElement);
    },
    handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.sliderContents) {
          this.interSected = true;
          this.sliderContents = [];
          this.loadCategory();
        }
      })
    }
  },
  components: {
    Intersect,
    Grid: () => import(/* webpackChunkName: "Grid" */ "@/components/Templates/GridLayout.vue"),
    GridLayoutPlaceholder: () => import(/* webpackChunkName: "gridplaceholder" */ "@/components/placeholders/GridLayoutPlaceholder.vue"),
  },
};
</script>

<style lang="scss" scoped>
.collection-title {
  padding: 0.5rem 2rem;
  text-align: center;
  text-transform: uppercase;
  opacity: 0.7;
}
</style>